<template>
  <div class="choose-enter-shop-container">
    <el-dialog :title="$t('moreShop.title')" :visible.sync="dialogVisible" width="70%" @close="handleClose">

        <el-row :gutter="20">
          <el-col :span="24">
            <p v-if="errorInfo" style="color: red;">{{ errorInfo }}</p>
            <el-row :gutter="20" class="mb-20">
              <el-col :span="12"></el-col>
              <el-col :span="6">
                <el-input-group class="flex justify-start">
                  <el-input v-model="searchShopName" :placeholder="$t('moreShop.searchPlaceholder')" clearable
                    @keyup.enter.native="handleQuery" />
                  <el-button slot="append" type="primary" @click="handleQuery">
                    {{ $t('common.search') }}
                  </el-button>
                </el-input-group>
              </el-col>
            </el-row>

            <el-table :data="shopInfo" border style="width: 100%">
              <el-table-column prop="shopId" :label="$t('moreShop.shopId')" align="center" />
              <el-table-column prop="shopName" :label="$t('moreShop.shopName')" align="center" />
              <el-table-column prop="storeAddress" :label="$t('moreShop.address')" align="center" />
              <el-table-column :label="$t('common.operation')" align="center" width="150">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary" @click="handleChooseShop(scope.row)">
                    {{ $t('common.select') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination :current-page.sync="pagination.current" :page-sizes="[10, 20, 30, 50]"
              :page-size="pagination.size" :total="pagination.total" layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange" @current-change="handleCurrentChange" />
          </el-col>
        </el-row>

    </el-dialog>
  </div>
</template>

<script>
import { listMyEnteredShops } from '@/api/frame/wuyeRegisterApi'
import { setCurrentShop } from '@/utils/vc'

export default {
  name: 'MoreShop',
  data() {
    return {
      dialogVisible: false,
      searchShopName: '',
      shopInfo: [],
      errorInfo: '',
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      communityId: ''
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.searchShopName = ''
      this.pagination.current = 1
      this.listEnterShop(this.pagination.current, this.pagination.size)
    },
    async listEnterShop(page, size) {
      try {
        // 必须用 listMyEnteredShops：管理员看商户全部店铺，普通员工仅看角色已授权店铺
        const res = await listMyEnteredShops({
          page,
          row: size,
          shopName: this.searchShopName
        })
        this.shopInfo = res.data || []
        this.pagination.total = res.total || 0
      } catch (error) {
        this.errorInfo = this.$t('moreShop.fetchError')
        console.error('请求失败:', error)
      }
    },
    handleChooseShop(shop) {
      setCurrentShop(shop)
      location.reload()
    },
    handleQuery() {
      this.pagination.current = 1
      this.listEnterShop(this.pagination.current, this.pagination.size)
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.listEnterShop(this.pagination.current, val)
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.listEnterShop(val, this.pagination.size)
    },
    handleClose() {
      this.dialogVisible = false
      this.errorInfo = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.choose-enter-shop-container {
  .el-dialog__body {
    padding: 20px;
  }

  .mb-20 {
    margin-bottom: 20px;
  }
}
</style>